import { formatIntegerNumber } from "@aprao/common/src/numberFormats.js";
import type { ShapeRevenueGroup } from "@aprao/model/src/shapes/ShapeRevenueGroup.js";

export const buildRevenueItemDescription = (
  locales: Intl.LocalesArgument,
  quantifiable: ShapeRevenueGroup["items"][number],
) =>
  quantifiable.quantity < 2 ?
    quantifiable.description
  : `${quantifiable.description} (×${formatIntegerNumber(
      locales,
      quantifiable.quantity,
    )})`;
